export default __webpack_public_path__ + "static/media/Dr Prabu Selvam.e258ff3b.jpg";